import { Controller } from "@hotwired/stimulus"

// テーブル行全体をクリック可能にする
//
//   <tr data-controller="clickable-row"
//       data-clickable-row-url-value="/path"
//       data-action="click->clickable-row#navigate keydown->clickable-row#keydown">
export default class extends Controller {
  static values = {
    url: String,
    turbo: { type: Boolean, default: false },
    frame: String
  }

  connect() {
    this.element.classList.add("clickable-row")
  }

  navigate(event) {
    if (this.shouldIgnore(event)) return
    this.go()
  }

  keydown(event) {
    if (event.key !== "Enter" && event.key !== " ") return
    event.preventDefault()
    this.go()
  }

  shouldIgnore(event) {
    return Boolean(event.target.closest("a, button, input, select, textarea, label"))
  }

  go() {
    if (!this.urlValue) return

    if (this.turboValue && this.hasFrameValue) {
      Turbo.visit(this.urlValue, { frame: this.frameValue })
      return
    }

    if (this.turboValue) {
      Turbo.visit(this.urlValue)
    } else {
      window.location.assign(this.urlValue)
    }
  }
}
